import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationApproveOauthConsentArgs,
  BackendOAuthConsentResult,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ApproveOAuthConsent($authorizeUrl: String!, $workspaceId: ID!) {
    approveOauthConsent(authorizeUrl: $authorizeUrl, workspaceId: $workspaceId) {
      redirectUrl
    }
  }
`;

type Variables = BackendMutationApproveOauthConsentArgs;
type Result = BackendOAuthConsentResult;

export const approveOAuthConsent = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
